import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_ADVERTISEMENT = createActionType("ADD_ADVERTISEMENT");
export const GET_ADVERTISEMENTS = createActionType("GET_ADVERTISEMENTS");
export const GET_ADVERTISEMENT_BY_ID = createActionType(
  "GET_ADVERTISEMENT_BY_ID"
);
export const EDIT_ADVERTISEMENT = createActionType("EDIT_ADVERTISEMENT");
export const REMOVE_ADVERTISEMENT = createActionType("REMOVE_ADVERTISEMENT");

export const addCooperation = (data: any) =>
  createAsyncAction(
    ADD_ADVERTISEMENT,
    "/cooperation/add_cooperation",
    "post",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getCooperations = () =>
  createAsyncAction(
    GET_ADVERTISEMENTS,
    "/cooperation/get_all_cooperations",
    "get",
    undefined
  );

export const getACooperationById = (data: any) =>
  createAsyncAction(
    GET_ADVERTISEMENT_BY_ID,
    `/cooperation/get_cooperation_by_id/${data}`,
    "get",
    undefined
  );

export const editCooperation = (id: any, data: any) =>
  createAsyncAction(
    EDIT_ADVERTISEMENT,
    `/cooperation/edit_cooperation/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeCooperation = (data: any) =>
  createAsyncAction(
    REMOVE_ADVERTISEMENT,
    `/cooperation/remove_cooperation/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
